import React from 'react';
import { Container, Content } from './styles';

// import { Container } from './styles';

const Footer: React.FC = ({ children }) => {
    return <Container>
        {!children && <Content>Copyright © 2022</Content>}
        {children && <Content>{children}</Content>}
    </Container>;
}

export default Footer;